'use strict';
 /**
 * @author Maxim Seredkin
 */
import angular from "angular";
import ProjectPlanFundByYearModalCreate from "./controller/planFundByYearModalCreate";
import ProjectPlanFundByYearTableDirective from "./directive/projectPlanFundByYearTable";

export default angular.module('investmentProject.project.fund.planByYear', [])
    .controller('ProjectPlanFundByYearModalCreateController', ProjectPlanFundByYearModalCreate)
    .directive('projectPlanFundByYearTable', ProjectPlanFundByYearTableDirective)
    .name;